import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import * as Types from './purchasePlus_graphql'

export const ProductUnitSizeProductFragmentDoc = gql`
  fragment ProductUnitSizeProduct on ProductInterface {
    id
    stockItem
    itemSize
    itemMeasure
    itemPackName
  }
` as unknown as DocumentNode<Types.ProductUnitSizeProductFragment, unknown>
